import { getAllDiscountPanelSuggestions, getBfsTestIds, getTestIdsForBestDealFunc, getSuggestBundlesAndLeftOverTestsForNewVw, replaceWithParentTests } from "@/utils/va-order-test/bestDealSuggestion";
import { removeSelectedCustomPanel } from "@/utils/va-order-test/testAndPanelSelection/customPanelSelection";
import { removeSelectedDiscountPanel } from "@/utils/va-order-test/testAndPanelSelection/discountPanelSelection";
import { removeSelectedSeasonalPromo } from "@/utils/va-order-test/testAndPanelSelection/seasonalPromoSelection";
import { removeSelectedShortcut } from "@/utils/va-order-test/testAndPanelSelection/shortcutSelection";
import { getTestNode, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
import { removeSelectedXChooseYPanel } from "@/utils/va-order-test/testAndPanelSelection/xChooseYPanelSelection";
import { getItemNameByLanguage } from "../../order-test-panel/order-test-tabs/testCard";

export function getTestNameList(item, data, language) {
  if (!item) {
    return [];
  }
  let { testNodeList, bundleList } = data;
  let testsOrBundles = getTestsOrBundles(item, testNodeList, bundleList);
  let nameList = testsOrBundles.map(item => {
    return getItemNameByLanguage(item, language);
  })
  const markupPriceList = testsOrBundles.map(item => {
    return item.defaultMarkupPrice? item.defaultMarkupPrice : 0;
  })
  let totalPrice = testsOrBundles.map(item => item.price).reduce((pre,cur) => pre + cur,0)
  // not show included tests in seasonal promo contains only one test
  if (item.category === "seasonalPromo" && nameList.length === 1) {
    nameList = [];
  }
  return { nameList, totalPrice, markupPriceList };
}

export function getTestsOrBundles(item, testNodeList, bundleList) {
  let testsOrBundles = [];
  switch (item.category) {
    case "discountPanel":
      testsOrBundles = getTestsInDiscountPanel(item.testIdsInPanel, testNodeList);
      break;
    case "customPanel":
      testsOrBundles = getItemsInCustomPanel(item.bundleItemList, testNodeList, bundleList);
      break;
    case "va":
    case "vw":
      testsOrBundles = getTestsInTestGroup(item.id, testNodeList);
      break;
    case "xChooseY":
      testsOrBundles = getTestsInXChooseYPanel(item, testNodeList);
      break;
    case "seasonalPromo":
      testsOrBundles = testNodeList
        .filter(t => item.testIdsInPromo.has(t.id))
        .map(node => node.value);
      break;
    case "shortcut":
      testsOrBundles = getItemsInShortcut(item, testNodeList, bundleList);
      break;
    default:
      break;
  }
  return testsOrBundles;
}

export function getTestsInDiscountPanel(testIdsInPanel, testNodeList) {
  let result = [];
  testIdsInPanel.forEach(testId => {
    let foundNode = getTestNode(testNodeList, testId);
    if (foundNode) {
      result.push(foundNode.value);
    }
  });
  return result;
}

function getItemsInCustomPanel(itemList, testNodeList, bundleList) {
  let result = [];
  itemList.forEach(test => {
    if (test.itemType === "official bundle") {
      if (test.itemId) {
        let foundPanel = bundleList.find(panel => panel.bundleId === test.itemId);
        if (foundPanel) {
          result.push(foundPanel);
        }
      }
    }
    else {
      if (test.itemId) {
        let foundNode = getTestNode(testNodeList, test.itemId);
        if (foundNode) {
          result.push(foundNode.value);
        }
      }
    }
  });
  return result;
}

function getTestsInTestGroup(testGroupId, testNodeList) {
  let result = [];
  let foundNode = getTestNode(testNodeList, testGroupId);
  if (foundNode) {
    result = foundNode.descendants.map(d => d.value);
  }
  return result;
}

function getTestsInXChooseYPanel(xChooseY, testNodeList) {
  let result = [];
  let { selectedZoomerIdList, selectedSupplementIdList } = xChooseY;
  let selectedTestIdList = (selectedZoomerIdList ? selectedZoomerIdList : [])
    .concat(selectedSupplementIdList ? selectedSupplementIdList : []);  
  result = testNodeList
    .filter(t => selectedTestIdList.includes(t.id))
    .map(node => node.value);
  return result;
}

function getItemsInShortcut(shortcut, testNodeList, bundleList) {
  let result = [];
  let { testIdList, discountPanelIdList, customPanelIdList, xChooseYIdList } = shortcut;
  testIdList.forEach(testId => {
    let foundNode = getTestNode(testNodeList, testId);
    if (foundNode) {
      result.push(foundNode.value);
    }
  });
  let bundleIds = discountPanelIdList.concat(customPanelIdList)
    .concat(xChooseYIdList.map(i => i.bundleId));
  let bundles = bundleList.filter(b => bundleIds.includes(b.bundleId));
  result = bundles.concat(result);
  return result;
}

export function removeItemInSelectedItemList(item, orderTestSupportObj) {
  switch (item.category) {
    case "customPanel":
      removeSelectedCustomPanel(item.bundleId, "isSelect", orderTestSupportObj);
      break;
    case "xChooseY":
      removeSelectedXChooseYPanel(item.bundleId, "isSelect", orderTestSupportObj);
      break;
    case "discountPanel":
      removeSelectedDiscountPanel(item.bundleId, "isSelect", orderTestSupportObj);
      break;
    case "va":
    case "vw":
      removeSelectedTest(item.id, "isSelect", orderTestSupportObj);
      break;
    case "seasonalPromo":
      removeSelectedSeasonalPromo(item, "isSelect", orderTestSupportObj);
      break;
    case "shortcut":
      removeSelectedShortcut(item.id, "isSelect", orderTestSupportObj);
      break;
    default:
      break;
  }
}

export function formatMarkupDataForApi(markupPrice, item, userInfo) {
  const markup_type = "fixed_profit"
  const markup_value = Math.round(Number(markupPrice) *100) / 100;
  const account_type = userInfo.isClinic ? "clinic" : "customer";
  let account_id;
  let affiliate_id;

  if (account_type === "customer") {
    account_id = userInfo.customer_id;
    affiliate_id = userInfo.clinic_id;
  } else {
    account_id = userInfo.clinic_id;
    affiliate_id = userInfo.customer_id;
  }

  const item_type = item.category === "va" || item.category === "vw" 
                      ? "packagePriceId" 
                      : item.category === "shortcut"
                        ? "shortcutId"
                        : item.category === "seasonalPromo"
                          ? "oldPromotionId"
                          : "bundleId";
  const item_id = ["packagePriceId", "shortcutId", "oldPromotionId"].includes(item_type) 
                    ? item.id
                    : item.bundleId;
  const item_name = item_type === "packagePriceId" ? item.displayName
                      : item_type === "seasonalPromo"
                        ? item.discountName
                        : item_type === "bundleId"
                          ? item.bundleName
                          : item.shortcutName;

  const customized_name = item.customizedName ? item.customizedName : null;
  const data = {
    account_id,
    account_type,
    markup_schemes: {}
  };
  data.markup_schemes[affiliate_id] = [
    {
      changeable: true,
      item_id: String(item_id),
      item_name,
      item_type,
      markup_type,
      markup_value,
      customized_name
    }
  ]
  
  return { data, newDefaultMarkupPrice: markup_value, affiliate_id }
}

export function updateMarkupInfo(newDefaultMarkupPrice, affectedItem) {
  if (!affectedItem) {
    return;
  }
  affectedItem.defaultMarkupPrice = newDefaultMarkupPrice;
  if (affectedItem.customizedName) {
    affectedItem.orignalCustomizedName = affectedItem.customizedName
  }
}

export function findInAppPromo(orderTestSupportObj, discountMap, isDbs) {
  let isHideSuggestionPromos = localStorage.getItem("isHideSuggestionPromos") === "true" ? true : false;
  if (isHideSuggestionPromos) {
    return [];
  }
  let { selectedDiscountPanelIdList, selectedXChooseYPanelIdList } = orderTestSupportObj;
  let testIds = getTestIdsForBestDealFunc(orderTestSupportObj);
  let allSuggestions = getAllDiscountPanelSuggestions(testIds, discountMap, orderTestSupportObj);
  // remove duplicate suggestions
  allSuggestions = allSuggestions.map(s => ({...s})).filter((s, index, self) => 
    index === self.findIndex(t => t.bundleId === s.bundleId)
  );

  let selectedPanelIdList = selectedDiscountPanelIdList.concat(selectedXChooseYPanelIdList);
  let eligibleSuggestions = findEligibleSuggestions(allSuggestions, selectedPanelIdList, testIds, orderTestSupportObj, isDbs);
  // console.log("eligibleSuggestions", [...eligibleSuggestions]);

  findSavingsForSuggestions(eligibleSuggestions, testIds, orderTestSupportObj, discountMap, isDbs);

  // sort the suggestions by savings in descending order
  eligibleSuggestions = eligibleSuggestions.filter(suggestion => !suggestion.ineligible);
  eligibleSuggestions.sort((a, b) => b.savings - a.savings);

  // return the first two suggestions only
  let firstTwoSuggestions = eligibleSuggestions.slice(0, 2);

  if (firstTwoSuggestions.length < 2) {
    return firstTwoSuggestions;
  }

  // special case: if the second suggestion has negative or zero addOnPrice, 
  // and the first suggestion has a positive addOnPrice (even the saving of first one is bigger)
  // then put it to the first
  // and remove the first suggestion
  if (firstTwoSuggestions[1].addOnPrice <= 0 && firstTwoSuggestions[0].addOnPrice > 0) {
    firstTwoSuggestions = [firstTwoSuggestions[1], firstTwoSuggestions[0]];
  }

  // special case:
  // if the first second suggestion has contents that are all belong to the first suggestion 
  // & they have the same remaining quantity
  // & the second sugestion has greater price than the first one
  // then remove the second suggestion
  // let firstSuggestion = firstTwoSuggestions[0];
  // let secondSuggestion = firstTwoSuggestions[1];
  // let isContainAll = secondSuggestion.bundleContentIds.every(id => firstSuggestion.bundleContentIds.includes(id));
  // let isSameRemainingQuantity = firstSuggestion.remainingQuantity === secondSuggestion.remainingQuantity;
  // let isGreaterPrice = secondSuggestion.finalPrice > firstSuggestion.finalPrice;
  // if (isContainAll && isSameRemainingQuantity && isGreaterPrice) {
  //   return [firstSuggestion];
  // }

  return firstTwoSuggestions;
}

export function findExclusiveAddOns(orderTestSupportObj, discountMap, isDbs) {
  let { testNodeList } = orderTestSupportObj;
  
  if (!discountMap) {
    return [];
  }

  let eligibleAddOns = [];
  let { exceptionMap } = orderTestSupportObj;

  // Add eligible single test addons using ADDITION_ENABLE exception
  if (exceptionMap && exceptionMap.ADDITION_ENABLE) {
    exceptionMap.ADDITION_ENABLE.forEach(exception => {
      if (!exception.itemId) {
        return;
      }
      
      let exceptionTestNode = getTestNode(testNodeList, exception.itemId);
      if (!exceptionTestNode || !exceptionTestNode.value) {
        return;
      }
      
      // Check if the exception test is eligible (isNotAllowedSelect === false means it's selectable)
      // and the exception test itself is not already selected
      let isEligible = exceptionTestNode.value.isNotAllowedSelect === false;
      let isExceptionTestSelected = exceptionTestNode.value.isSelect === true;
      
      // If eligible and not already selected, add it as an addon
      if (isEligible && !isExceptionTestSelected) {
        let sampleTypeSets = exceptionTestNode.value.sampleTypeSets || null;
        let infoIcon = exceptionTestNode.value.infoIcon || null;
        
        eligibleAddOns.push({
          id: exception.itemId,
          testName: exceptionTestNode.value.displayName,
          addOnPrice: exceptionTestNode.value.price || 0,
          originalPrice: exceptionTestNode.value.originalPrice || 0,
          sampleTypeSets,
          infoIcon
        });
      }
    });
  }

  // add eligibletests with conditionalDiscounts using price comparison
  if (testNodeList && Array.isArray(testNodeList)) {
    testNodeList.forEach(node => {
      if (node && node.value && !node.value.isNotAllowedSelect) {
        const test = node.value;
        // Check if test has conditionalDiscounts and meets eligibility criteria
        if (test.conditionalDiscounts) {
          // Check if price is less than original price and test is not selected
          const hasDiscount = test.price < test.originalPrice ? true : false;
          const isNotSelected = test.isSelect !== true;
          
          if (hasDiscount && isNotSelected) {
            // Get sampleTypeSets and infoIcon from the test
            let sampleTypeSets = test.sampleTypeSets || null;
            let infoIcon = test.infoIcon || null;
            
            eligibleAddOns.push({
              id: test.id,
              testName: test.displayName || test.testName || '',
              addOnPrice: test.price || 0,
              originalPrice: test.originalPrice || 0,
              sampleTypeSets,
              infoIcon
            });
          }
        }
      }
    });
  }

  // Remove duplicate add-ons and keep the one with the cheapest addOnPrice
  // Group by id and keep only the one with minimum addOnPrice
  const addOnMap = new Map();
  eligibleAddOns.forEach(addOn => {
    const existingAddOn = addOnMap.get(addOn.id);
    if (!existingAddOn || addOn.addOnPrice < existingAddOn.addOnPrice) {
      addOnMap.set(addOn.id, addOn);
    }
  });
  eligibleAddOns = Array.from(addOnMap.values());

  // console.log("eligibleAddOns", eligibleAddOns);

  return eligibleAddOns;
}

/**
 * find eligible suggestions
 * @param {array} allSuggestions - all suggestions
 * @param {array} selectedPanelIdList - selected discount panel and x choose y panel id list
 * @param {array} testIds - test ids
 * @param {object} orderTestSupportObj - order test support object
 * @param {boolean} isDbs - current menu version
 * @returns {array} eligible suggestions
 */
function findEligibleSuggestions(allSuggestions, selectedPanelIdList, testIds, orderTestSupportObj, isDbs) {
  let { bundleList, testNodeList } = orderTestSupportObj;
  let selectedPanelList = bundleList.filter(b => selectedPanelIdList.includes(b.bundleId));
  let eligibleMenu = isDbs ? ["at_home", "both"] : ["not_at_home", "both"];
  // shallow copy so adding remainingQuantity etc. does not mutate the original suggestions
  let suggestionsCopy = allSuggestions.map(s => ({ ...s }));
  let eligibleSuggestions = suggestionsCopy
   .filter(suggestion => !selectedPanelIdList.includes(suggestion.bundleId)) // remove suggestion that was already selected
   .filter(suggestion => { // remove suggestions that are not eligible for current menu version or are hide for in app promo suggestion
     let bundle = bundleList.find(b => b.bundleId === suggestion.bundleId);
     if (bundle && !eligibleMenu.includes(bundle.section)) {
       return false;
     }
     return true;
   })
   .filter(suggestion => {
      let { selectedMainIds, selectedSupplementIds, ineligible } = getSelectedTestIdsInSuggestion(
        suggestion,
        testIds,
        testNodeList,
        selectedPanelList,
        orderTestSupportObj
      );
      if (ineligible) return false;
      if (suggestion.quantity) {
        if (selectedMainIds.length > suggestion.quantity || selectedSupplementIds.length > (suggestion.supplementQuantity ?? 0)) {
          return false;
        }
      }
      // add-on ids: main and supplement pools not yet selected
      let addonMainTestIds = suggestion.bundleContentIds.filter(id => !selectedMainIds.includes(id));
      let addonSupplementTestIds = (suggestion.supplementList || []).filter(id => !selectedSupplementIds.includes(id));
      if (!suggestion.quantity) {
        // normal bundle only: normalize to parent-level
        addonMainTestIds = replaceWithParentTests(addonMainTestIds, testNodeList, true);
        addonSupplementTestIds = replaceWithParentTests(addonSupplementTestIds, testNodeList, true);
      }

      // pre-save for findSavingsForSuggestions and downstream
      suggestion.addonMainTestIds = addonMainTestIds;
      suggestion.addonSupplementTestIds = addonSupplementTestIds;
      suggestion.selectedMainIds = selectedMainIds;
      suggestion.selectedSupplementIds = selectedSupplementIds;
      if (suggestion.quantity) {
        suggestion.remainingQuantityMain = Math.max(0, suggestion.quantity - selectedMainIds.length);
        suggestion.remainingQuantitySupplement = Math.max(0, (suggestion.supplementQuantity || 0) - selectedSupplementIds.length);
      } else {
        suggestion.remainingQuantityMain = addonMainTestIds.length;
        suggestion.remainingQuantitySupplement = addonSupplementTestIds.length;
      }
      let remainingQuantity = suggestion.remainingQuantityMain + suggestion.remainingQuantitySupplement;
      suggestion.remainingQuantity = remainingQuantity;
      // normal bundle: eligible if only 1 add-on test (parent-level)
      if (!suggestion.quantity) {
        return remainingQuantity === 1;
      }
      // x choose y bundle: eligible if 1 add-on test
      return remainingQuantity > 0 && remainingQuantity <= 1;
   });
  return eligibleSuggestions;
}

/**
 * Get leaf test ids for an array of ids (concatenated). Single-id logic inlined (getTestNode + getBfsTestIds).
 * @param {array} testNodeList - test node list
 * @param {array} ids - test or panel ids
 * @returns {array} leaf test ids
 */
export function getLeafIdsForIdArray(testNodeList, ids) {
  let out = [];
  (ids || []).forEach(id => {
    let node = getTestNode(testNodeList, id);
    if (node) getBfsTestIds(node, out);
    else out.push(id);
  });
  return out;
}

/**
 * Get leaf test ids in a panel (discount panel or x choose y).
 */
function getPanelLeafTestIds(panel, testNodeList) {
  let panelTestIdsRaw =
    panel.category === "discountPanel"
      ? panel.testIdsInPanel
      : (panel.selectedZoomerIdList || []).concat(panel.selectedSupplementIdList || []);
  return getLeafIdsForIdArray(testNodeList, panelTestIdsRaw);
}

/**
 * Return testIds excluding those that already form the given selected panels (discount / x choose y).
 * - Discount suggestion: for each selected panel, if all of the panel's tests are covered by the suggestion's pool (main/supplement), the panel could be upgraded to this suggestion so count its ids as effective (do not exclude). Otherwise exclude. If the suggestion's leaves overlap with any excluded panel (need to split), returns [] (ineligible).
 * - x choose y suggestion: for selected discount panels, if all of the panel's leaf ids are in the suggestion's main or supplement pool (no split), count those ids as effective (do not exclude). For selected x choose y panels, if panel's main quantity <= suggestion's main quantity and panel's supplement quantity <= suggestion's supplement quantity, the panel can be replaced by the suggestion so count its test ids as effective (do not exclude). Otherwise exclude.
 * @param {array} testIds - current selected test ids
 * @param {array} selectedPanelList - selected discount / x choose y panels
 * @param {array} testNodeList - test node list
 * @param {object} suggestion - current suggestion
 * @returns {array} effective test ids
 */
function getTestIdsExcludingSelectedPanels(testIds, selectedPanelList, testNodeList, suggestion) {
  if (!selectedPanelList || selectedPanelList.length === 0) return testIds;

  let suggestionTestIds = (suggestion.bundleContentIds || []).concat(suggestion.supplementList || []);
  let suggestionLeafIds = getLeafIdsForIdArray(testNodeList, suggestionTestIds);
  let suggestionLeafSet = new Set(suggestionLeafIds);

  let idsToExclude = new Set();
  selectedPanelList.forEach(panel => {
    let panelLeaves = getPanelLeafTestIds(panel, testNodeList);
    if (suggestion.quantity) {
      if (panel.category === "discountPanel") {
        if (panelLeaves.length > 0 && panelLeaves.every(leafId => suggestionLeafSet.has(leafId))) {
          return;
        }
      } else if (panel.category === "xChooseY") {
        let panelMainOk = (panel.quantity ?? 0) <= (suggestion.quantity ?? 0);
        let panelSuppOk = (panel.supplementQuantity ?? 0) <= (suggestion.supplementQuantity ?? 0);
        if (panelMainOk && panelSuppOk) {
          return;
        }
      }
    } else {
      if (panelLeaves.length > 0 && panelLeaves.every(leafId => suggestionLeafSet.has(leafId))) {
        return;
      }
    }
    panelLeaves.forEach(leafId => idsToExclude.add(leafId));
  });

  let filtered = testIds.filter(id => !idsToExclude.has(id));
  if (!suggestion.quantity) {
    if (suggestionLeafSet.size > 0 && [...suggestionLeafSet].some(leafId => idsToExclude.has(leafId))) {
      return [];
    }
  }
  return filtered;
}

/**
 * Find the selected test ids in a suggestion (main pool + supplement pool).
 * When selectedPanelList is provided, test ids that already form those panels are excluded before matching.
 * For discount panel suggestions, if need to split any selected panel then effectiveTestIds is [] (suggestion ineligible).
 * @param {object} suggestion - suggestion with bundleContentIds and optional supplementList
 * @param {array} testIds - current selected test ids (leaf-only)
 * @param {array} testNodeList - test node list
 * @param {array} [selectedPanelList] - optional; when provided, tests in these panels are excluded from counting
 * @param {object} [orderTestSupportObj] - optional; required when selectedPanelList is used for discount-panel split check
 * @returns {{ selectedMainIds: array, selectedSupplementIds: array, ineligible?: boolean }} ineligible is true when effectiveTestIds is empty (suggestion treated as ineligible)
 */
export function getSelectedTestIdsInSuggestion(suggestion, testIds, testNodeList, selectedPanelList, orderTestSupportObj) {
  let effectiveTestIds = getTestIdsExcludingSelectedPanels(testIds, selectedPanelList, testNodeList, suggestion);
  // console.log("suggestion", suggestion);
  // console.log("effectiveTestIds", effectiveTestIds);
  if (effectiveTestIds.length === 0) {
    return { selectedMainIds: [], selectedSupplementIds: [], ineligible: true };
  }
  let testIdsSet = new Set(effectiveTestIds);
  let selectedMainIds = [];
  let selectedSupplementIds = [];

  function tryMatchAndConsume(id, resultPart) {
    let leafIds = getLeafIdsForIdArray(testNodeList, [id]);
    let allLeavesInSet = leafIds.length > 0 && leafIds.every(leafId => testIdsSet.has(leafId));
    if (allLeavesInSet) {
      resultPart.push(id);
      leafIds.forEach(leafId => testIdsSet.delete(leafId));
    }
  }

  (suggestion.bundleContentIds || []).forEach(id => tryMatchAndConsume(id, selectedMainIds));
  (suggestion.supplementList || []).forEach(id => tryMatchAndConsume(id, selectedSupplementIds));
  // console.log("selectedMainIds", selectedMainIds);
  // console.log("selectedSupplementIds", selectedSupplementIds);
  return { selectedMainIds, selectedSupplementIds };
}

function getPriceForIds(ids, testNodeList) {
  return ids.reduce((sum, id) => {
    let node = getTestNode(testNodeList, id);
    return sum + (node && node.value && node.value.price != null ? node.value.price : 0);
  }, 0);
}

/**
 * find savings, addOnTest info, real addon price for eligible suggestions
 * For normal discount panel suggestion (no quantity): use best deal logic for add-on price; ineligible if best deal bundle list doesn't include the suggestion.
 * for xChooseY panel suggestion (with quantity): find any selected items that contain the suggestion's selected main and supplement tests, then calculate the add-on price by subtracting the selected items price from the suggestion's final price.
 * for all suggestions: calculate the savings by subtracting the selected items price and add-on test price from the suggestion's final price.
 * 
 * @param {array} eligibleSuggestions - eligible suggestions
 * @param {array} testIds - test ids
 * @param {object} orderTestSupportObj - order test support object
 * @param {object} discountMap - discount map
 * @param {boolean} isDbs - is DBS version
 */
function findSavingsForSuggestions(eligibleSuggestions, testIds, orderTestSupportObj, discountMap, isDbs) {
  let { testNodeList, selectedItemList } = orderTestSupportObj;

  eligibleSuggestions.forEach(suggestion => {
    let selectedMainIds = suggestion.selectedMainIds || [];
    let selectedSupplementIds = suggestion.selectedSupplementIds || [];
    let selectedPriceForSuggestion = getPriceForIds(selectedMainIds, testNodeList) + getPriceForIds(selectedSupplementIds, testNodeList);

    let addonTestPrice = 0;
    if (suggestion.quantity) {
      let leafIdsFromMain = getLeafIdsForIdArray(testNodeList, selectedMainIds);
      let leafIdsFromSupplement = getLeafIdsForIdArray(testNodeList, selectedSupplementIds);
      let selectedSuggestiontestIdsWithParent = [...new Set(selectedMainIds.concat(selectedSupplementIds).concat(leafIdsFromMain).concat(leafIdsFromSupplement))];
      let selectedSuggestionItems = selectedItemList.filter(item => {
        if (item.category === "discountPanel") {
          return item.testIdsInPanel.some(id => selectedSuggestiontestIdsWithParent.includes(id));
        }
        if (item.category === "xChooseY") {
          let ids = (item.selectedZoomerIdList || []).concat(item.selectedSupplementIdList || []);
          return ids.some(id => selectedSuggestiontestIdsWithParent.includes(id));
        }
        if (["va", "vw"].includes(item.category)) {
          let itemLeafIds = getLeafIdsForIdArray(testNodeList, [item.id]);
          return itemLeafIds.some(id => selectedSuggestiontestIdsWithParent.includes(id));
        }
        return false;
      });
      let selectedItemsPrice = selectedSuggestionItems.reduce((sum, item) => sum + (item.price ?? 0), 0);
      suggestion.addOnPrice = (suggestion.finalPrice ?? 0) - selectedItemsPrice;
      let addonMainTestIds = suggestion.addonMainTestIds || [];
      let addonSupplementTestIds = suggestion.addonSupplementTestIds || [];
      let remainingMain = suggestion.remainingQuantityMain ?? 0;
      let remainingSupplement = suggestion.remainingQuantitySupplement ?? 0;
      let possibleAddedMainTests = testNodeList.filter(t => addonMainTestIds.includes(t.id));
      let possibleAddedSupplementTests = testNodeList.filter(t => addonSupplementTestIds.includes(t.id));
      possibleAddedMainTests.sort((a, b) => b.value.price - a.value.price);
      possibleAddedSupplementTests.sort((a, b) => b.value.price - a.value.price);
      addonTestPrice = possibleAddedMainTests.slice(0, remainingMain).reduce((pre, cur) => pre + cur.value.price, 0) +
        possibleAddedSupplementTests.slice(0, remainingSupplement).reduce((pre, cur) => pre + cur.value.price, 0);
    } else {
      let addOnTestIds = (suggestion.addonMainTestIds || []).concat(suggestion.addonSupplementTestIds || []);
      if (addOnTestIds.length !== 1) {
        suggestion.ineligible = true;
        return;
      }
      let addOnTestId = addOnTestIds[0];
      let addOnTestNode = getTestNode(testNodeList, addOnTestId);
      if (!addOnTestNode || !addOnTestNode.value) {
        suggestion.ineligible = true;
        return;
      }
      addonTestPrice = addOnTestNode.value.price ?? 0;
      suggestion.addOnTest = {
        id: addOnTestNode.id,
        testName: addOnTestNode.value.testName,
        price: addOnTestNode.value.price,
        originalPrice: addOnTestNode.value.originalPrice
      };
      let testIdsWithAddOn = [...new Set([...testIds, addOnTestId])];
      let { suggestBundleList, bestDealPrice } = getSuggestBundlesAndLeftOverTestsForNewVw(
        testIdsWithAddOn,
        orderTestSupportObj,
        discountMap,
        isDbs
      );
      let isSuggestedBundleInBestDeal = suggestBundleList.some(
        b => (b.appliedBundleId !== undefined && b.appliedBundleId === suggestion.bundleId) || b.bundleId === suggestion.bundleId
      );
      if (!isSuggestedBundleInBestDeal) {
        suggestion.ineligible = true;
        return;
      }
      let selectedTotalItemsPrice = selectedItemList.reduce((sum, item) => sum + (item.price ?? 0), 0);
      suggestion.addOnPrice = bestDealPrice - selectedTotalItemsPrice;
    }

    suggestion.savings = Math.round(selectedPriceForSuggestion + addonTestPrice - (suggestion.finalPrice ?? 0));
  });
}
